export default "__VITE_ASSET__180552c2__"